"use client";

import { Icon, type IconName } from "@/lib/icons/Icon";
import styles from "./TabHeader.module.css";

/**
 * Spójny header dla wszystkich widoków w main area panel klienta — core tabs
 * (Twoje dane / Hasło / Konto) ORAZ plugin views (extension actions).
 *
 * Layout: ikona po lewej + opcjonalny "parent" label (uppercase, mały) + tytuł.
 *
 * @example
 *   <TabHeader icon="user" title="Twoje dane" />
 *   <TabHeader icon="envelope-simple" title="Skrzynka odbiorcza" parent="Prywatne wiadomości" />
 */
export function TabHeader({
  icon,
  title,
  parent,
}: {
  icon: IconName;
  title: string;
  parent?: string;
}) {
  return (
    <header className={styles.tabHeader}>
      <Icon name={icon} className={styles.tabHeaderIcon} />
      <div className={styles.tabHeaderTitles}>
        {parent && <p className={styles.tabHeaderParent}>{parent}</p>}
        <h2 className={styles.tabHeaderTitle}>{title}</h2>
      </div>
    </header>
  );
}
